export const TERMINAL_OUTBOX_STATUSES = new Set([
  'blocked',
  'cancel_requested',
  'cancelled',
  'canceled',
  'sent',
  'completed',
  'delivered',
  'failed',
  'dead_lettered',
  'duplicate_skipped',
  'opt_out_skipped'
]);

export function isPendingOutboxItem(item = {}) {
  const status = String(item.status || '').trim().toLowerCase();
  if (item.cancelRequested === true) return false;
  if (status && TERMINAL_OUTBOX_STATUSES.has(status)) return false;
  return Boolean(item.clientId);
}

export function countPendingOutboxByClient(items = []) {
  return items.reduce((counts, item) => {
    if (!isPendingOutboxItem(item)) return counts;
    counts[item.clientId] = (counts[item.clientId] || 0) + 1;
    return counts;
  }, {});
}

// A blocked item is terminal, so the pending count above drops it and the badge
// goes to zero -- which is exactly what made a launch that never sent look like
// a launch that finished. These two read the same items for the other half of
// the story, and change nothing about what "pending" means.
export function isBlockedOutboxItem(item = {}) {
  if (!item.clientId) return false;
  if (item.cancelRequested === true) return false;
  const status = String(item.status || '').trim().toLowerCase();
  if (status === 'blocked') return true;
  if (status && TERMINAL_OUTBOX_STATUSES.has(status)) return false;
  // A bare `failureReason` is NOT enough: an item that is still retrying after a
  // transient failure carries one, and calling that "not sent" would be a false alarm.
  return Boolean(item.blockedReason);
}

export function summarizeBlockedOutboxByClient(items = []) {
  return items.reduce((summary, item) => {
    if (!isBlockedOutboxItem(item)) return summary;
    const entry = summary[item.clientId] || { count: 0, reason: '', guidance: '' };
    entry.count += 1;
    // The first reason seen is the one shown. Blocked items on one campaign come
    // from a single failed launch, so they share it.
    if (!entry.reason) {
      entry.reason = String(item.blockedReason || item.terminalReason || item.failureReason || '').trim();
      entry.guidance = String(item.blockedGuidance || item.failureGuidance || '').trim();
    }
    summary[item.clientId] = entry;
    return summary;
  }, {});
}
